export const BranchChips = ({ branches, selected, onToggle, prefix = "branch-chip" }) => (
  <div className="flex flex-wrap gap-2">
    {branches.map((b) => (
      <button
        key={b.id}
        type="button"
        data-testid={`${prefix}-${b.id}`}
        onClick={() => onToggle(b.id)}
        className={`rounded-full border px-3 py-2 text-xs font-semibold transition-colors duration-200 ${
          selected.includes(b.id)
            ? "border-primary/50 text-primary shadow-neu-in"
            : "border-border/60 text-muted-foreground shadow-neu-sm"
        }`}
      >
        {b.name}
      </button>
    ))}
  </div>
);
